var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGroupProfile = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29688 17.6484L1.29721 14.6481C1.2974 12.9914 2.64049 11.6484 4.29721 11.6484H10.2968M12.7969 14.1484L13.7969 15.1484L17.2969 11.6484M13.7969 1.64844C15.0104 2.32867 15.7969 3.41917 15.7969 4.64844C15.7969 5.87771 15.0104 6.96821 13.7969 7.64844M11.2969 4.64844C11.2969 6.30529 9.95373 7.64844 8.29687 7.64844C6.64002 7.64844 5.29687 6.30529 5.29687 4.64844C5.29687 2.99158 6.64002 1.64844 8.29687 1.64844C9.95373 1.64844 11.2969 2.99158 11.2969 4.64844Z",
    stroke: "#5579F0",
    strokeWidth: 1.67467,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGroupProfile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/GroupProfile.72337ba3.svg";
export { ForwardRef as ReactComponent };